import React, { useContext, useState, useRef } from "react";
import { LangContext } from "../../context/LangContext";
import Bread from "../../common/Bread";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Loader from "../../common/Loader";
import { Modal } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./crossborderpayment.scss";

function CrossBorderpayment() {
  const lang = useContext(LangContext);
  const nep = lang.state.np;
  const sliderRef = useRef(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);
  const [currentTitle, setCurrentTitle] = useState("");

  const breadcrumList = {
    image: "",
    title: nep ? "सीमापार भुक्तानी" : "Cross Border Payment",
    l1: nep ? "होम" : "Home",
    l2: nep ? "सीमापार भुक्तानी" : "Cross Border Payment",
    l3: "",
  };

  const { isLoading, error, data, isFetching } = useQuery({
    queryKey: ["crossborder_payment"],
    queryFn: () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/crossborder_payment/all`)
        .then((res) => res.data),
  });

  if (isLoading || isFetching) return <Loader />;
  if (error) return <h3>{error.message}</h3>;

  const crossborderpaymentdata = nep ? data?.items?.np : data?.items?.en;

  const openLightbox = (images, title, index) => {
    setCurrentImages(images);
    setCurrentTitle(title);
    setActiveIndex(index);
    setModalOpen(true);
    setTimeout(() => {
      sliderRef.current?.slickGoTo(index, true);
    }, 100);
  };

  const closeLightbox = () => {
    setModalOpen(false);
  };

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: false,
    beforeChange: (oldIndex, newIndex) => setActiveIndex(newIndex),
  };

  return (
    <Bread data={breadcrumList}>
      <div className="crossborder-payment">
        {crossborderpaymentdata?.map((item) => (
          <div className="payment-item" key={item.id}>
            <div className="payment-header">
              <h2>{item.Title}</h2>
            </div>

            {item.Description && (
              <div
                className="payment-description"
                dangerouslySetInnerHTML={{
                  __html: item.Description,
                }}
              />
            )}

            {item.images?.length > 0 && (
              <div className="image-gallery-section">
                {/* <h3>{nep ? "ग्यालरी" : "Gallery"}</h3> */}
                <div className="image-gallery">
                  {item.images.map((img, index) => (
                    <div
                      className="gallery-card"
                      key={index}
                      onClick={() =>
                        openLightbox(item.images, item.Title, index)
                      }
                    >
                      <img
                        src={img.DocPath}
                        alt={img.file_alt || item.Title || ""}
                        loading="lazy"
                      />
                      <div className="gallery-overlay">
                        <span className="expand-icon">+</span>
                      </div>
                      {item.images.length > 1 && (
                        <span className="image-counter">
                          {index + 1}/{item.images.length}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      <Modal open={modalOpen} onClose={closeLightbox}>
        <div className="modal-lightbox">
          <button className="modal-close" onClick={closeLightbox}>
            ✕
          </button>
          <Slider ref={sliderRef} {...sliderSettings}>
            {currentImages.map((img, index) => (
              <div className="modal-image-wrap" key={index}>
                <img
                  src={img.DocPath}
                  alt={img.file_alt || currentTitle || `Image ${index + 1}`}
                />
              </div>
            ))}
          </Slider>
          <div className="modal-footer">
            <p className="modal-title">{currentTitle}</p>
            {currentImages.length > 1 && (
              <span className="modal-counter">
                {activeIndex + 1} / {currentImages.length}
              </span>
            )}
          </div>
        </div>
      </Modal>
    </Bread>
  );
}

export default CrossBorderpayment;
